/* tslint:disable:only-arrow-functions */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';
import { MenuService } from '../core/menu/menu.service';
import { ClientLayoutComponent } from '../layouts/client/client-layout.component';
import { ClientLayoutModule } from '../layouts/client/client-layout.module';
import { DashboardLayoutComponent } from '../layouts/dashboard/dashboard-layout.component';
import { DashboardLayoutModule } from '../layouts/dashboard/dashboard-layout.module';
import { EmptyComponent } from './empty.component';
import { CustomerExistsGuard } from '../services/routing/customer-exists.guard';
import { DefaultRouteGuard } from '../services/routing/default-route.guard';
import { LoggedInGuard } from '../services/routing/logged-in.guard';
import { AccessDashboardGuard } from '../services/routing/permission-guards/access-dashboard.guard';
import { ClientViewCustomerDataGuard } from '../services/routing/permission-guards/client/view-customer-data.guard';
import { SearchNameExistsGuard } from '../services/routing/search-name-exists.guard';
import { LoginModule } from './login/login.module';
import { SidebarMenu } from './menu';

export const routes: Route[] = [
  {
    path: '',
    canActivate: [LoggedInGuard, DefaultRouteGuard],
    children: [],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    canActivate: [LoggedInGuard, AccessDashboardGuard],
    loadChildren: './dashboard/dashboard.module#DashboardModule',
  },
  {
    path: 'client/:customerName',
    component: ClientLayoutComponent,
    canActivate: [LoggedInGuard, CustomerExistsGuard, ClientViewCustomerDataGuard],
    loadChildren: './client/client.module#ClientModule',
  },
  {
    path: 'client_redirect',
    component: EmptyComponent,
    canActivate: [SearchNameExistsGuard],
  },
];

@NgModule({
  imports: [
    CommonModule,
    ClientLayoutModule,
    DashboardLayoutModule,
    RouterModule.forRoot(routes),
    LoginModule,
  ],
  exports: [
    RouterModule,
  ],
  providers: [
    CustomerExistsGuard,
    LoggedInGuard,
    DefaultRouteGuard,
    SearchNameExistsGuard,
  ],
})
export class EnrichRoutingModule {
  constructor(private menuService: MenuService) {
    this.menuService.addMenu(SidebarMenu);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/routing.module.ts